const config = {
    colors: {
        primary: "#a83b91",
        secondary: "#2ecc71",
        background: "#f4f4f4",
        text: "#333333",
    },
};

export default config;
